import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["as", "children", "classes", "namespace"];
import React from 'react';
import classNames from 'classnames/bind';
import { elementType, node, shape, string } from 'prop-types';
import { defaultPropObject } from "../constants";
import { getMethodsForTestId } from "../utils/getMethodsForTestId";
import styles from './IconRound.css';
var cx = classNames.bind(styles);

var IconRound = function IconRound(_ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'span' : _ref$as,
      children = _ref.children,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      namespace = _ref.namespace,
      props = _objectWithoutProperties(_ref, _excluded);

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'iconRound'),
      getTestId = _getMethodsForTestId.getTestId;

  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cx('root', classes.root)
  }, getTestId(), props), children);
};

IconRound.propTypes = process.env.NODE_ENV !== "production" ? {
  as: elementType,
  children: node.isRequired,
  classes: shape({
    root: string
  }),
  namespace: string
} : {};
IconRound.defaultProps = {
  as: 'span',
  classes: {}
};
export default IconRound;